import { AdminSettingPermission } from './admin-settings.permission';
import { AdminPermissions } from './admin.permissions';
import { CallPermission } from './call.permissions';
import {
    CaseCommunicationPermissions,
    CaseContactPermissions,
    CaseCourtDatePermissions,
    CaseDocumentPermissions,
    CaseDocumentTypesPermissions,
    CaseHistoryPermissions,
    CaseNotePermissions,
    CasePermissions,
    CaseRequiredDocumentsPermissons,
    CaseTaskPermissions,
    CaseTypesPermissions
} from './case.permission';
import { ClaimPermissions } from './claim.permission';
import { ClientPermission } from './client.permission';
import { DashboardPermissions } from './dashboard.permissions';
import { DiaryPermissions } from './diary.permissions';
import { PaymentPermissions } from './payment.permissions';
import { ServiceProviderPermission } from './service-provider.permission';
import { UserPermission } from './user.permission';

export class Permission {
    public static readonly Dashboard = DashboardPermissions;
    public static readonly Diary = DiaryPermissions;

    public static readonly Cases = CasePermissions;
    public static readonly CaseTypes = CaseTypesPermissions;
    public static readonly CaseCourtDates = CaseCourtDatePermissions;
    public static readonly CaseNotes = CaseNotePermissions;
    public static readonly CaseTasks = CaseTaskPermissions;
    public static readonly CaseHistory = CaseHistoryPermissions;

    public static readonly CaseDocuments = CaseDocumentPermissions;
    public static readonly CaseRequiredDocuments =
        CaseRequiredDocumentsPermissons;

    public static readonly CaseDocumentTypes = CaseDocumentTypesPermissions;

    public static readonly CaseContacts = CaseContactPermissions;
    public static readonly CaseCommunications = CaseCommunicationPermissions;

    public static readonly AdminSettings = AdminSettingPermission;
    public static readonly Payments = PaymentPermissions;

    public static readonly Client = ClientPermission;

    public static readonly ServiceProvider = ServiceProviderPermission;
    public static readonly User = UserPermission;

    public static readonly Claim = ClaimPermissions;

    public static readonly Admin = AdminPermissions;

    public static readonly Call = CallPermission;
}
